import React from 'react'
import img8 from '../../assets/course/image-1.png'
import img2 from '../../assets/course/image-2.png'
import img7 from '../../assets/course/image-3.png'
import img4 from '../../assets/course/image-4.png'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const Courseintern = () => {
  return (
    <div>
         <div class="coursebox-section ws-section dark-background-2 pb-5">
            <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <h2 class="ws-section_heading pd-03">Customized Internship Programs</h2>
                </div>
                <div class="col-lg-4 align-self-center">
                    <a href='/courses'>
                    <button class="btn-primary btn-icon" href="index.html#about">View All Courses<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                </a>
                </div>
            </div>

            <div class="row align-items-center gx-xl-28 mt-5">
                <div class="col-lg-6 mb-5">
                    <a href='/product/physical-design'>
                    <div class="course-box">
                        <div class="course-box-top">
                            <img src={img8} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='/product/physical-design'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">Physical Design Internship</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Offline | Online | Mixed | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">Physical Design Training course mainly focused on giving complete hands on experience to physical design and physical verification training flow with latest tools and full lab practice.</p>
                        </div>
                    </div>
                    </a>
                </div>
                <div class="col-lg-6 mb-5">
                    <a href='/product/design-for-test/'>
                <div class="course-box">
                        <div class="course-box-top">
                            <img src={img2} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='/product/design-for-test/'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">Design For Test (DFT) Internship</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Offline | Online | Mixed | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">Design For Testability (DFT) is a specialization in the SOC design cycle, to detect the manufacturing defects in a design. With the increase in size & complexity of chips.</p>
                        </div>
                    </div>
                    </a>
                </div>
                <div class="col-lg-6 mb-5">
                    <a href='/product/asic-verification/'>
                <div class="course-box">
                        <div class="course-box-top">
                            <img src={img7} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='/product/asic-verification/'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">ASIC Verification Internship</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Offline | Online | Mixed | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">Mainly focused on enhancing the Design Verification skills needed by industry. The curriculum is designed to include the latest methodologies being adopted by industry.</p>
                        </div>
                    </div>
                    </a>
                </div>
                <div class="col-lg-6 mb-5">
                    <a href='/product/analog-layout-design/'>
                    <div class="course-box">
                        <div class="course-box-top">
                            <img src={img4} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='/product/analog-layout-design/'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">Analog Layout Design Internship</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Offline | Online | Mixed | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">Analog Layout Design / Custom Layout Design / IC design training course mainly focused on giving hands-on practical exposure in doing chip layout design for a given analog & mixed signal design.</p>
                        </div>
                    </div>
                    </a>
                </div>
                

                
            </div>

        </div>
    </div>
    </div>
  )
}

export default Courseintern